/**
 * This function adds keyboard/mouse controls for the menu.
 *
 * @param menuElement - the parent element/menu block.
 */
const menu = menuElement => {

  if (!menuElement) {
    return;
  }

  const acatoVariables = window.vvd_variables || {}; // Passed by wp_localize_script.
  const allSubmenus = menuElement.querySelectorAll( '.menu__submenu' );
  const dropdownToggleButtons = Array.from( menuElement.querySelectorAll( '.menu__submenu-toggle-button' ) );
  const dropdownHoverToggles = Array.from( menuElement.querySelectorAll( '.header__nav > .menu > .menu__item--has-submenu' ) );
  const menuOverlay = document.querySelector( '.menu-overlay' );
  const masthead = document.querySelector( '.masthead' );

  /**
   * On open...
   *  - Change the text in the button to 'Hide' (translatable string from class-assets.php).
   *  - Add the class 'menu__submenu-toggle--active' to the dropdown list to show the dropdown visually.
   *  - Set aria-hidden to false on the submenu to inform screen readers that the popup is not hidden anymore.
   *  - Set aria-expanded to true on the toggle button to inform screen readers that the popup is open.
   *
   * @param dropdownMenu
   */
  const openDropdownMenu = (dropdownMenu) => {
    const dropdownList = dropdownMenu.querySelector( '.menu__submenu' ) || dropdownMenu.parentNode.querySelector( '.menu__submenu' );
    const showTextElement = dropdownMenu.querySelector( '.menu__show-submenu' ) || dropdownMenu.parentNode.querySelector( '.menu__show-submenu' );
    const submenuToggleButton = dropdownMenu.querySelector( '.menu__submenu-toggle-button' ) || dropdownMenu.parentNode.querySelector( '.menu__submenu-toggle-button' );

    showTextElement.textContent = acatoVariables?.hide_submenu_text || 'Hide';
    dropdownList.classList.add( 'menu__submenu--active' );
    dropdownList.setAttribute( 'aria-hidden', 'false' );
    submenuToggleButton.setAttribute( 'aria-expanded', 'true' );
    menuOverlay.classList.add( 'active' );

    if (window.innerWidth > 1200) {
      masthead.classList.add( 'menu-open' );
    }
  }

  /**
   * On close...
   *  - Do the reverse of on open.
   *
   * @param dropdownMenu
   */
  const closeDropdownMenu = (dropdownMenu) => {
    const dropdownList = dropdownMenu.parentNode.querySelector( '.menu__submenu' );
    const showTextElement = dropdownMenu.parentNode.querySelector( '.menu__show-submenu' );
    const submenuToggleButton = dropdownMenu.parentNode.querySelector( '.menu__submenu-toggle-button' );

    showTextElement.textContent = acatoVariables?.show_submenu_text || 'Show';
    dropdownList.classList.remove( 'menu__submenu--active' );
    dropdownList.setAttribute( 'aria-hidden', 'true' );
    submenuToggleButton.setAttribute( 'aria-expanded', 'false' );
    menuOverlay.classList.remove( 'active' );

    if (window.innerWidth > 1200) {
      masthead.classList.remove( 'menu-open' );
    }
  }

  menuOverlay.addEventListener( 'click', () => {
    closeAllDropdownMenus();
  } );

  const closeAllDropdownMenus = () => {
    dropdownToggleButtons.forEach( dropdownMenu => closeDropdownMenu( dropdownMenu ) );
  }

  const toggleDropdownMenu = (event) => {
    if (event.target.getAttribute( 'aria-expanded' ) === 'false') {
      closeAllDropdownMenus();
      openDropdownMenu( event.target );
      return;
    }

    closeDropdownMenu( event.target );
  }

  const closeSubmenusWhenMastheadIsHidden = () => {
    const masthead = document.querySelector( '.masthead' );
    const mastheadHeight = getComputedStyle( document.documentElement ).getPropertyValue( '--header-height' ).replace( 'px', '' );
    let lastScrollTop = 0;

    if (masthead && window.innerWidth > 1200) {
      window.addEventListener( 'scroll', (event) => {
        let currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (currentScrollTop > lastScrollTop && currentScrollTop > mastheadHeight) {
          closeAllDropdownMenus();
        }

        lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
      } );
    }
  };


  const keyDownHandler = event => {
    const currentMenuItem = event.target.closest( '.menu__item' );
    const menuItems = [...menuElement.querySelectorAll( '.menu__item' )]
    const currentIndex = menuItems.findIndex( (item) => item === currentMenuItem );

    const key = event.key;
    let targetItem = null;

    if (key === 'ArrowRight') {
      if (menuItems.indexOf( currentMenuItem ) === menuItems.length - 1) {
        targetItem = menuItems[0];
      } else {
        targetItem = menuItems[currentIndex + 1];
      }
    }

    if (key === 'ArrowLeft') {
      if (menuItems.indexOf( currentMenuItem ) === 0) {
        targetItem = menuItems[menuItems.length - 1];
      } else {
        targetItem = menuItems[currentIndex - 1];
      }
    }

    if (key === 'Escape') {
      targetItem = menuItems[0];
      closeAllDropdownMenus();
    }

    const currentDropdownMenu = event.target.closest( '.menu__item--has-submenu .menu__submenu-toggle' );

    if (currentDropdownMenu) {
      const firstDropdownItem = currentDropdownMenu.nextElementSibling.querySelector( '.menu__submenu-item' );

      if (key === 'ArrowDown') {
        event.preventDefault();
        openDropdownMenu( currentDropdownMenu );
        targetItem = firstDropdownItem;
      }

      if (key === 'Escape') {
        closeDropdownMenu( currentDropdownMenu );
      }
    }

    const currentDropdownMenuItem = event.target.closest( '.menu__item--has-submenu .menu__submenu-item' );

    if (currentDropdownMenuItem) {
      const currentDropdownList = currentDropdownMenuItem.parentNode;
      const dropdownMenuItems = [...currentDropdownList.querySelectorAll( '.menu__submenu-item:has(a)' )];
      const currentIndex = dropdownMenuItems.findIndex( (item) => item === currentDropdownMenuItem );

      if (key === 'ArrowDown') {
        event.preventDefault();

        if (dropdownMenuItems.indexOf( currentDropdownMenuItem ) === dropdownMenuItems.length - 1) {
          targetItem = dropdownMenuItems[0];
        } else {
          targetItem = dropdownMenuItems[currentIndex + 1];
        }
      }

      if (key === 'ArrowUp') {
        event.preventDefault();

        if (dropdownMenuItems.indexOf( currentDropdownMenuItem ) === 0) {
          targetItem = dropdownMenuItems[dropdownMenuItems.length - 1];
        } else {
          targetItem = dropdownMenuItems[currentIndex - 1];
        }
      }

      if (key === 'Escape') {
        const currentDropdownMenu = currentDropdownList.previousElementSibling;
        targetItem = currentDropdownMenu.parentNode;
        closeAllDropdownMenus();
      }
    }

    if (targetItem) {
      console.log( targetItem );
      targetItem.querySelector( 'a, button, input' ).focus();
    }
  }

  const handleMouseEnter = event => {
    openDropdownMenu( event.target );
  };

  const handleMouseLeave = event => {
    closeAllDropdownMenus();
  };

  const addHoverEvents = () => {
    if (getComputedStyle( document.querySelector( '[data-open-menu]' ) )?.display === 'none') {
      dropdownHoverToggles.forEach( dropdownMenu => {
        dropdownMenu.addEventListener( 'mouseenter', handleMouseEnter );
        dropdownMenu.addEventListener( 'mouseleave', handleMouseLeave );
      } );
    } else {
      dropdownHoverToggles.forEach( dropdownMenu => {
        dropdownMenu.removeEventListener( 'mouseenter', handleMouseEnter );
        dropdownMenu.removeEventListener( 'mouseleave', handleMouseLeave );
      } );
    }
  };

  if (allSubmenus) {
    allSubmenus.forEach( submenu => {
      const allItems = submenu.querySelectorAll( 'li' );
      const lastItem = submenu.querySelector( 'li:last-child' );

      allItems.forEach( item => {
        item.addEventListener( 'keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            closeAllDropdownMenus();
          }
        } );
      } );

      lastItem.addEventListener( 'keydown', event => {
        if (event.key === 'ArrowRight' || (event.key === 'Tab' && !event.shiftKey)) {
          closeAllDropdownMenus();
        }
      } );
    } );
  }

  menuElement.addEventListener( 'keydown', keyDownHandler );

  // window.addEventListener( 'click', event => {
  //   const element = event.target
  //   if (!element.hasAttribute( 'aria-haspopup' ) && !element.classList.contains( 'menu__submenu-item' )) {
  //     closeAllDropdownMenus();
  //   }
  // } );

  window.addEventListener( 'resize', () => {
    addHoverEvents();
  } );

  closeSubmenusWhenMastheadIsHidden();
  addHoverEvents();

  dropdownToggleButtons.forEach( dropdownMenu => {
    dropdownMenu.addEventListener( 'click', toggleDropdownMenu );
  } );
}

export default menu;
